import { render } from "./DogTag.vue?vue&type=template&id=41284db3&scoped=true"
import script from "./DogTag.vue?vue&type=script&lang=js"
export * from "./DogTag.vue?vue&type=script&lang=js"

import "./DogTag.vue?vue&type=style&index=0&id=41284db3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41284db3"]])

export default __exports__